import React, { useState, useCallback } from 'react'
import { Modal, Input, Row, Message } from '@iqueue/ui-kit'
import SensorPresenter from '../api/sensorPresenter'
import { t } from '../hooks/useTranslate'

export default function DataModal({ formModal, closeModal, data = null, currentSensorId }) {
  const [values, setValues] = useState({})

  const handleChange = useCallback((key, value) => {
    setValues((prev) => ({ ...prev, [key]: value }))
  }, [])

  const handleApply = useCallback(async (item) => {
    const formattedItem = Object.entries(item).reduce((acc, [key, value]) => {
      const { type } = data[key] || {}

      if (type && type.toLowerCase() === 'array') {
        acc[key] = value
          .split(',')
          .map((item) => item.trim())
          .filter((item) => item !== '')
          .map(Number)
      } else {
        acc[key] = value
      }

      return acc
    }, {})

    await SensorPresenter.post(`${ currentSensorId }/send-command`, { commands: formattedItem }).then(() => {
      Message({
        type: 'success',
        timeout: 3000,
        title: t('sensorsSendCommand.successRequest'),
      })
    }).catch((err) => {
      Message({
        type: 'error',
        timeout: 5000,
        title: err?.message,
      })
    })

  }, [data])

  return <Modal
    isOpened={ formModal }
    onClose={ () => closeModal(false) }
    title={ t('sensorsSendCommand.parameters') }
    fullscreen={ data && true }
    onApply={ (item) => {
      handleApply(item).catch(console.error)
    } }
    footerActions={ data ? [
      { key: 'close', danger: true, title: t('modal.editWellStatusModal.close') },
      { key: 'save', primary: true, submit: true, title: t('sensorsSendCommand.send') },
    ] : [{ key: 'close', danger: true, title: t('modal.editWellStatusModal.close') }]}
  >

    { data ? Object.entries(data).map(([key, { type }]) => {
      return <Row key={ key }>
        { type.toLowerCase() === 'array' ? <Input
          type="text"
          name={ key }
          size={ 12 }
          value={ Array.isArray(values[key]) ? values[key].join(', ') : values[key] || '' }
          onChange={ (e) => handleChange(key, e.target.value.split(',').map((item) => item.trim())) }
          placeholder={ `${ t('sensorsSendCommand.enterValuesCommaSeparated') }: ${ key }` }
          onKeyDown={ (e) => {
            if (e.key === ' ') {
              e.preventDefault()
              if (!e.target.value.endsWith(', ')) {
                handleChange(key, e.target.value.trim() + ', ')
              }
            }
          } }
        /> : <Input
          type={ type.toLowerCase() }
          name={ key }
          size={ 12 }
          value={ values[key] || '' }
          onChange={ (e) => handleChange(key, e.target.value) }
          placeholder={ `${ t('sensorsSendCommand.enterValue') }: ${ key }` }
        /> }
      </Row>
    }) : <h6>{ t('sensorsSendCommand.modelDoesNotSupportForm') }</h6> }
  </Modal>
}
